import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FiAlertCircle, FiCheckCircle, FiGlobe, FiSlash, FiCornerUpRight } from 'react-icons/fi';
import Layout from '../components/Layout';
import ErrorBoundary from '../components/ErrorBoundary';

const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'ngrok-skip-browser-warning': 'true',
});

const RedirectDashboardContent = () => {
    const [stats, setStats] = useState({
        total: 0,
        active: 0,
        inactive: 0,
        remainPath: 0,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchStats = async () => {
            try {
                setLoading(true);
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/api/redirect-domains/stats`,
                    { headers: authHeaders() }
                );
                if (response.data.success) {
                    setStats(response.data.data);
                }
            } catch (err) {
                setError(`Failed to fetch statistics: ${err.response?.data?.error || err.message}`);
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, []);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <div className="space-y-6 w-full max-w-none px-8">
            <div className="bg-white rounded-lg shadow p-6">
                <h2 className="text-xl font-semibold mb-6">Redirect Dashboard Overview</h2>

                {error && (
                    <div className="mb-6 p-4 bg-red-100 text-red-700 rounded-md flex items-center">
                        <FiAlertCircle className="mr-2" />
                        {error}
                    </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div className="bg-blue-50 p-4 rounded-lg">
                        <div className="flex items-center">
                            <FiGlobe className="h-8 w-8 text-blue-600" />
                            <div className="ml-4">
                                <h3 className="text-lg font-medium text-blue-800">Total Domains</h3>
                                <p className="text-3xl font-bold text-blue-600">{stats.total}</p>
                            </div>
                        </div>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg">
                        <div className="flex items-center">
                            <FiCheckCircle className="h-8 w-8 text-green-600" />
                            <div className="ml-4">
                                <h3 className="text-lg font-medium text-green-800">Enable</h3>
                                <p className="text-3xl font-bold text-green-600">{stats.active}</p>
                            </div>
                        </div>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg">
                        <div className="flex items-center">
                            <FiSlash className="h-8 w-8 text-gray-600" />
                            <div className="ml-4">
                                <h3 className="text-lg font-medium text-gray-800">Disable</h3>
                                <p className="text-3xl font-bold text-gray-700">{stats.inactive}</p>
                            </div>
                        </div>
                    </div>
                    <div className="bg-amber-50 p-4 rounded-lg">
                        <div className="flex items-center">
                            <FiCornerUpRight className="h-8 w-8 text-amber-600" />
                            <div className="ml-4">
                                <h3 className="text-lg font-medium text-amber-800">Remain Path</h3>
                                <p className="text-3xl font-bold text-amber-600">{stats.remainPath}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const RedirectDashboard = () => (
    <Layout>
        <ErrorBoundary
            fallbackTitle="Redirect Dashboard Error"
            fallbackDescription="An error occurred while loading the Redirect dashboard. Please try again or contact support if the problem persists."
        >
            <RedirectDashboardContent />
        </ErrorBoundary>
    </Layout>
);

export default RedirectDashboard;
